import React, { useEffect } from 'react';

const BeneficiaryDetailsModal = ({ beneficiary, onClose }) => {
  // Handle ESC key press - Move this BEFORE the early return
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleEscKey);
    
    // Prevent body scrolling when modal is open
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  // Early return AFTER all hooks
  if (!beneficiary) return null;

  // Define fields to display
  const detailFields = [
    { key: 'farmerName', label: 'Farmer Name' },
    { key: 'fatherSpousesName', label: 'Father/Spouse Name' },
    { key: 'mobileNo', label: 'Mobile No' },
    { key: 'gender', label: 'Gender' },
    { key: 'casterCategory', label: 'Caste Category' },
    { key: 'beneficiaryCode', label: 'Beneficiary Code' },
    { key: 'demoType', label: 'Demo Type' },
    { key: 'financialYear', label: 'Financial Year' },
    { key: 'season', label: 'Season' },
    { key: 'cropGroup', label: 'Crop Group' },
    { key: 'crop', label: 'Crop' },
    { key: 'cropVariety', label: 'Crop Variety' },
    { key: 'demoAreaInHa', label: 'Demo Area (Ha)' },
    { key: 'stateName', label: 'State' },
    { key: 'districtName', label: 'District' },
    { key: 'blockName', label: 'Block' },
    { key: 'villageName', label: 'Village' },
    { key: 'surveyorName', label: 'Surveyor Name' },
    { key: 'inputName1', label: 'Input 1' },
    { key: 'inputQty1', label: 'Quantity 1' },
    { key: 'inputUnit1', label: 'Unit 1' },
    { key: 'inputName2', label: 'Input 2' },
    { key: 'inputQty2', label: 'Quantity 2' },
    { key: 'inputUnit2', label: 'Unit 2' },
    { key: 'inputName3', label: 'Input 3' },
    { key: 'inputQty3', label: 'Quantity 3' },
    { key: 'inputUnit3', label: 'Unit 3' }
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h5>Beneficiary Details</h5>
          <button 
            className="close-btn" 
            onClick={onClose}
            aria-label="Close"
            title="Close (ESC)"
          >
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="details-grid">
            {detailFields.map(field => {
              const value = beneficiary[field.key];
              if (value && value !== null && value !== '' && value !== 'null') {
                return (
                  <div key={field.key} className="detail-row">
                    <div className="detail-label">{field.label}:</div>
                    <div className="detail-value">{String(value)}</div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
        {/* Footer with close button for better visibility */}
        <div className="modal-footer">
          <button 
            className="modal-close-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default BeneficiaryDetailsModal;